import React from 'react';
import {ListGroup, Card, Form} from 'react-bootstrap';
import useCheckFilterFieldsValidity from '../../util/useCheckFilterFieldsValidity';
import Filter from './Filter';
import createUUID from '../../util/createUUID';
import checkOtherFiltersValid from '../../util/checkOtherFiltersValid';

const FilterMultiSelectList = (props) => {
    const checkFieldsValidity = useCheckFilterFieldsValidity();
    return <Filter
        key={`filter-${props.filter.name}`}
        filters={props.filters}
        loading={props.loading}
        setFilters={props.setFilters}
        filter={props.filter}
        filtersInitial={props.filtersInitial}
    >
        <style>
            {
                `
                    .list-group-item:last-of-type {
                        border-bottom: none;
                    }

                    .invalid-feedback p:last-of-type {
                        margin-bottom: 0;
                    }
                `
            }
        </style>
        <Card
            style={
                {
                    ...(
                        !props.filter.valid ?
                            {
                                borderColor: `#dc3545`,
                                boxShadow: `0 0 0 .2rem rgba(220,53,69,.25)`
                            } :
                            {
                                boxShadow: 'none',
                                borderColor: 'rgba(0,0,0,0.125)'
                            }
                    )
                }
            }
        >
            <ListGroup
                id={`filter-${props.filter.name}`}
                variant="flush"
                className={!props.filter.valid ? `is-invalid` : null}
            >
                {
                    props.filter.config.options.map((option) => {
                        const optionEnabled = props.filter.value.indexOf(option) !== -1;
                        return <ListGroup.Item
                            key={option}
                        >
                            <Form.Label
                                className="mb-0"
                                htmlFor={`${props.filter.name}-option-${option}`}>
                                <Form.Check
                                    type="switch"
                                    title="Toggle Filter Option"
                                    disabled={props.loading}
                                    label={
                                        <span
                                            style={
                                                {
                                                    userSelect: 'none',
                                                    cursor: 'pointer',
                                                }
                                            }
                                        >{props.APIOptions[option]}</span>
                                    }
                                    id={`${props.filter.name}-option-${option}`}
                                    checked={optionEnabled}
                                    onChange={
                                        () => {
                                            const newValue = [...props.filter.value];
                                            if (optionEnabled) {
                                                newValue.splice(props.filter.value.indexOf(option), 1);
                                            } else {
                                                newValue.push(option);
                                            }

                                            const filterValidity = checkFieldsValidity(newValue, props.filter.validation);

                                            const othersValid = checkOtherFiltersValid(props.filter, props.filters);

                                            props.setFilters(
                                                {
                                                    ...props.filters,
                                                    changed: true,
                                                    valid: othersValid && filterValidity.valid,
                                                    filters: {
                                                        ...props.filters.filters,
                                                        [props.filter.name]: {
                                                            ...props.filter,
                                                            value: [...newValue],
                                                            touched: props.filtersInitial.filters[props.filter.name].value.length !== newValue.length ? true : false,
                                                            valid: filterValidity.valid,
                                                            errors: [...filterValidity.errors]
                                                        }
                                                    }
                                                }
                                            );
                                        }
                                    }
                                />
                            </Form.Label>
                        </ListGroup.Item>
                    })
                }
            </ListGroup>
        </Card>
        <div>
            <div className={!props.filter.valid ? "is-invalid" : null} />
            <Form.Control.Feedback
                type="invalid"
                className="pt-1"
            >
                {
                    props.filter.errors.map(error => {
                        return <p key={createUUID()}>{error}</p>
                    })
                }
            </Form.Control.Feedback>
        </div>
    </Filter>
}

export default FilterMultiSelectList;
